export const FIELD_TYPE = {
  CHECKBOX: 'checkbox',
  DATE: 'date',
  EMAIL: 'email',
  NUMBER: 'number',
  PASSWORD: 'password',
  PHONE: 'tel',
  RADIO: 'radio',
  RANGE: 'range',
  SELECT: 'select',
  TEXT: 'text',
  TEXT_AREA: 'textarea',
  POSTAL_CODE: 'postalCode',
  BASIC_RADIO: 'basicRadio'
};

export const VALIDATION = {
  EMAIL_REGEX: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
  PHONE_REGEX: /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g,
  ONLY_NUMBERS_REGEX: /^\d+$/,
  ONLY_NUMBERS_OR_DECIMAL_REGEX: /^[0-9]+([.,][0-9]+)?$/,
  NO_NUMBERS_REGEX: /^[^\d]*$/,
  SIRET_REGEX: /^[A-Z]{0,2}\d{8,14}$/ // Try global regex to work with lot of case but this is not very accurate
};

export const ERROR_TYPE = {
  REQUIRED: 'required',
  PHONE: 'phone',
  CONFIRM: 'confirm',
  DATE_OVER_LIMIT: 'dateOverLimit',
  DATE_UNDER_LIMIT: 'dateUnderLimit',
  SIRET: 'siret',
  INTRACOM_NUMBER: 'intracomNumber',
  ONLY_NUMBERS: 'onlyNumbers',
  ONLY_NUMBERS_OR_DECIMALS: 'onlyNumbersOrDecimal',
  ONLY_LATIN_CHARS: 'onlyLatinChars',
  POSTAL_CODE: 'postalCode',
  IS_ADULT: 'isAdult',
  EMAIL: 'isEmail',
  NO_NUMBER: 'noNumber'
};

export const SUPPORTED_TYPES = Object.values(FIELD_TYPE);

export const TEXT_TYPES = [FIELD_TYPE.TEXT, FIELD_TYPE.RANGE, FIELD_TYPE.NUMBER, FIELD_TYPE.TEXT_AREA];

export const POSTAL_CODE_REGEX = {
  DE: /^\d{5}$/i,
  AU: /^\d{4}$/i,
  BE: /^\d{4}$/i,
  DK: /^\d{4}$/i,
  ES: /^\d{5}$/i,
  FR: /^\d{2}\s{0,1}\d{3}$/i,
  GR: /^\d{3}\s{0,1}\d{2}$/i,
  IT: /^\d{5}$/i,
  LU: /^\d{4}$/i,
  NL: /^\d{4}\s{0,1}[A-Za-z]{2}$/i,
  PT: /^\d{4}[- ]{0,1}\d{3}$/i,
  GB: /^[a-zA-Z]{1,2}[0-9][a-zA-Z0-9]? ?[0-9][a-zA-Z]{2}$/i,
  SG: /^\d{6}$/i,
  CH: /^\d{4}$/i,
  CZ: /^\d{3}\s{0,1}\d{2}$/i,
  US: /^\d{5}(-\d{4})?$/i,
  SE: /^\d{3}\s\d{2}$/i
};

export const INTRACOM_NUMBER_REGEX = {
  AT: /^(AT)U\d{8}$/i,
  BE: /^BE ?\d{10}$/i,
  DE: /^(DE)([0-9]{9})$/i,
  ES: /^(ES)([A-Z]\d{8}|[A-Z]\d{7}[A-Z])$/i,
  GR: /^(EL)(\d{9})$/i,
  IE: /^(IE)([0-9A-Z\+\*]{8,9}[A-Z])$/i,
  IT: /^(IT)(\d{11})$/i,
  LU: /^(LU)(\d{8})$/i,
  NL: /^(NL)(\d{9})B\d{2}$/i,
  PT: /^(PT)(\d{9})$/i,
};
